import { PeopleQueryBaseDto } from "./people-query-base.dto";

export class PeopleBreakPeriodDto {
    id?: number;
    timeworked?: string;
    breakEarned?: string;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;
}
export interface PeopleBreakPeriodQueryDto extends PeopleQueryBaseDto {}